import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor, history } from './redux/store';
import './assets/vendors/style';
import './less/wieldy.less';
import 'react-quill/dist/quill.snow.css';
import ScrollToTop from './components/ScrollToTop';
import Routes from './routes';

const App = () => (
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Router history={history}>
                <ScrollToTop>
                    <Routes />
                </ScrollToTop>
            </Router>
        </PersistGate>
    </Provider>
);

export default App;
